import React from 'react';

import { Grid, Typography } from '@mui/material';

import { Job } from '@libs/graphql-types';
import { modelPath } from '@libs/helpers/form';
import ConnectedMultipleSelect from '@libs/ui/components/form/multiple-select/ConnectedMultipleSelect';

import { ApplicationFormState } from '../../types';

interface DefaultLocationCodesProps {
  job: Job;
  showOnlyRequired?: boolean;
}

const DEFAULT_LOCATION_OPTIONS = [
  { text: 'AKR001', value: 'AKR001' },
  { text: 'ALR001', value: 'ALR001' },
  { text: 'ARR001', value: 'ARR001' },
  { text: 'AZR001', value: 'AZR001' },
  { text: 'CAR001', value: 'CAR001' },
  { text: 'COR001', value: 'COR001' },
  { text: 'CTR001', value: 'CTR001' },
  { text: 'DCR001', value: 'DCR001' },
  { text: 'DER001', value: 'DER001' },
  { text: 'FLR001', value: 'FLR001' },
  { text: 'GAR001', value: 'GAR001' },
  { text: 'HIR001', value: 'HIR001' },
  { text: 'IAR001', value: 'IAR001' },
  { text: 'IDR001', value: 'IDR001' },
  { text: 'ILR001', value: 'ILR001' },
  { text: 'INN070', value: 'INN070' },
  { text: 'INR001', value: 'INR001' },
  { text: 'KSR001', value: 'KSR001' },
  { text: 'KYR001', value: 'KYR001' },
  { text: 'LAR001', value: 'LAR001' },
  { text: 'MAR001', value: 'MAR001' },
  { text: 'MDR001', value: 'MDR001' },
  { text: 'MER001', value: 'MER001' },
  { text: 'MIR001', value: 'MIR001' },
  { text: 'MNR001', value: 'MNR001' },
  { text: 'MOR001', value: 'MOR001' },
  { text: 'MSR001', value: 'MSR001' },
  { text: 'MTR001', value: 'MTR001' },
  { text: 'NCR001', value: 'NCR001' },
  { text: 'NDR001', value: 'NDR001' },
  { text: 'NER001', value: 'NER001' },
  { text: 'NHR001', value: 'NHR001' },
  { text: 'NJR001', value: 'NJR001' },
  { text: 'NMR001', value: 'NMR001' },
  { text: 'NVR001', value: 'NVR001' },
  { text: 'NYR001', value: 'NYR001' },
  { text: 'OHR001', value: 'OHR001' },
  { text: 'OKR001', value: 'OKR001' },
  { text: 'ORR001', value: 'ORR001' },
  { text: 'PAR001', value: 'PAR001' },
  { text: 'RIR001', value: 'RIR001' },
  { text: 'SCR001', value: 'SCR001' },
  { text: 'SDR001', value: 'SDR001' },
  { text: 'TNR001', value: 'TNR001' },
  { text: 'TXR001', value: 'TXR001' },
  { text: 'UTR001', value: 'UTR001' },
  { text: 'VAR001', value: 'VAR001' },
  { text: 'VTR001', value: 'VTR001' },
  { text: 'WAR001', value: 'WAR001' },
  { text: 'WIR001', value: 'WIR001' },
  { text: 'WVR001', value: 'WVR001' },
  { text: 'WYR001', value: 'WYR001' },
];

/**
 * Default Location Codes form component
 * This component renders the standard location code form for most job applications
 * using the standard site code and location code fields
 */
export const DefaultLocationCodes: React.FC<DefaultLocationCodesProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  return (
    <>
      <Grid item>
        <Typography variant="h6" gutterBottom>
          Location Information{' '}
          <Typography component="span" color="error">
            *
          </Typography>
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Please select the appropriate site code and location code for this
          position.
        </Typography>
      </Grid>

      <Grid item>
        <ConnectedMultipleSelect
          name={modelPath<ApplicationFormState>((i) => i.details.siteCode)}
          options={DEFAULT_LOCATION_OPTIONS}
          autoCompleteProps={{
            multiple: false,
            freeSolo: true,
          }}
          inputProps={{
            fullWidth: true,
            variant: 'filled',
            label: (
              <Typography>
                Site Code{' '}
                <Typography component="span" color="error">
                  *
                </Typography>
              </Typography>
            ),
          }}
        />
      </Grid>

      <Grid item>
        <ConnectedMultipleSelect
          name={modelPath<ApplicationFormState>((i) => i.details.siteCode)}
          options={DEFAULT_LOCATION_OPTIONS}
          autoCompleteProps={{
            multiple: false,
          }}
          inputProps={{
            fullWidth: true,
            variant: 'filled',
            disabled: true,
            label: (
              <Typography>
                Location Code{' '}
                <Typography component="span" color="error">
                  *
                </Typography>
              </Typography>
            ),
          }}
        />
      </Grid>
    </>
  );
};
